import Model from '@/models/Model'

export default class AccAccountingSeatConcept extends Model {
  resource() {
    return 'acc_accounting_seat_concept'
  }
}